
import React from 'react'
import styled from 'styled-components'

const Falg = styled.div`
  position: absolute;
  top: 14px;
  right: 8px;
  z-index: 1;
`

export default function FlagStatus ({artwork, ids, isMyArtwork}: {artwork: any, ids: any, isMyArtwork: any}) {
  const FlagFunction = () => {
    if (!artwork) return null
    if (artwork.nftLevel === 'v1') return null
    
    // 在拍卖
    if (+artwork.auctionPrice && !ids.includes(artwork.tokenId)) {
      return (
        <Falg>
          <img style={{width: '85px'}} src='/images/nft/onAuction.png' alt=""/>
        </Falg>
      )
    }

    // 我参与竞价/拍卖，挂单者撤单了
    if (!(+artwork.price) && ids.includes(artwork.tokenId) && isMyArtwork) {
      return (
        <Falg>
          <img style={{width: '119px'}} src='/images/nft/offerCancel.png' alt=""/>
        </Falg>
      )
    }

    // 我参与竞价/拍卖的。挂单者未撤单
    if (ids.includes(artwork.tokenId) && isMyArtwork) {
      return (
        <Falg>
          <img style={{width: '86px'}} src='/images/nft/offermade.png' alt=""/>
        </Falg>
      )
    }

    // 在卖的
    if (+artwork.price) {
      return (
        <Falg>
          <img style={{width: '62px'}} src='/images/nft/onSale.png' alt=""/>
        </Falg>
      )
    }

    return null
  }
  return  <FlagFunction />
}